import PigletRegistrationApi from "@/api/pig-registration/piglet/PigletRegistrationApi";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async add({dispatch}, form) {
      try {
        const response = await PigletRegistrationApi.add(form);
        dispatch('NOTIFY_MSG', 'pigRegistration.notification.pigletRegister', {root: true})
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async exist({dispatch}, {pigStyId, calendarWeekId}) {
      try {
        const response = await PigletRegistrationApi.exist(pigStyId, calendarWeekId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
